module.exports = __webpack_public_path__ + "../resources/images/emptyInbox-01fba529e922bad85d1709378b4a9848.svg";